<script>
	import { onMount, onDestroy } from 'svelte';
	import * as rive from '@rive-app/canvas-lite';
	// @ts-ignore
	import logoLoopRiv from '$lib/assets/images/shared/logo-loop.riv';
	import ModalAbcmouse from '$lib/components/ModalAbcmouse.svelte';
	import { app } from '$lib/stores/app/store';
	import { loadingService } from '$lib/services/loading';

	/** Show "Refresh" option after this many ms (user-facing refresh if loading is stuck). */
	const REFRESH_AFTER_MS = 60 * 1000;

	let showRefreshMessage = false;
	/** @type {ReturnType<typeof setTimeout> | null} */
	let refreshTimeout = null;
	/** @type {import('@rive-app/canvas-lite').Rive | null} */
	let riveInstance = null;

	$: loading = $app?.global?.loading;

	onMount(() => {
		const canvas = document.getElementById('loading-modal-rive-canvas');
		if (canvas && canvas instanceof HTMLCanvasElement) {
			riveInstance = new rive.Rive({
				src: logoLoopRiv,
				canvas,
				autoplay: true,
				onLoad: () => {
					riveInstance?.resizeDrawingSurfaceToCanvas?.();
				},
			});
		}
		refreshTimeout = setTimeout(() => {
			if (loading) showRefreshMessage = true;
		}, REFRESH_AFTER_MS);
	});

	onDestroy(() => {
		riveInstance?.cleanup();
		riveInstance = null;
		if (refreshTimeout) {
			clearTimeout(refreshTimeout);
			refreshTimeout = null;
		}
	});

	/**
	 *
	 */
	function handleRefresh() {
		loadingService.stop();
		window.location.reload();
	}
</script>

<ModalAbcmouse
	hideHeader
	hideModalClose
>
	<div
		slot="modal-content"
		class="flex flex-col items-center justify-center gap-4"
	>
		<canvas
			id="loading-modal-rive-canvas"
			class="h-auto w-[30rem] sm:w-[40rem]"
			aria-label="loading content"
		></canvas>
		{#if showRefreshMessage}
			<div class="flex flex-col items-center gap-4 rounded-md bg-white p-6 text-center sm:p-8">
				<p
					class="w-[20rem] font-abcmouse-sans text-[1.6rem] leading-tight sm:w-[30rem] sm:text-[2rem]"
				>
					Still loading... <br />
					Continue waiting or <br />refresh to try again.
				</p>
				<div class="flex gap-2">
					<button
						id="loading-modal-home-button"
						type="button"
						class="btn-header-rebrand btn-animated btn-header-rebrand-blue text-[1.6rem] sm:text-[2rem]"
						on:click={handleRefresh}
					>
						Refresh
					</button>
				</div>
			</div>
		{/if}
	</div>
</ModalAbcmouse>
